import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { MenuItemPath, MenuItem } from '@enums/menu-item.enum';
import { Role } from '@enums/role.enum';
import { AuthGuard } from 'app/core/guards/auth.guard';
import { SiteComponent } from './pages/site/site.component';

const routes: Routes = [
    {
      path: MenuItemPath.get(MenuItem.site),
      component: SiteComponent,
      canActivate: [AuthGuard],
      data: {
        role: [
          Role.administrator,
          Role.manager
        ]
      }
    }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
})

export class SiteRoutingModule { }
